module.exports = __webpack_public_path__ + "img/pirellu.2c7ac4ff.jpg";